"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asHiddenBreadcrumbSource = exports.BreadcrumbStoreProvider = exports.useBreadcrumbStore = void 0;

var react_1 = __importDefault(require("react"));

var server_1 = __importDefault(require("react-dom/server"));

var core_1 = require("@bodiless/core");

var BreadcrumbsStoreContext = react_1.default.createContext(undefined);
/**
 * Component that adds react context provider containing store to its children.
 */

var BreadcrumbStoreProvider = function BreadcrumbStoreProvider(_a) {
  var children = _a.children,
      store = _a.store;
  return react_1.default.createElement(BreadcrumbsStoreContext.Provider, {
    value: store
  }, children);
};

exports.BreadcrumbStoreProvider = BreadcrumbStoreProvider;
/**
 * React hook to get store.
 */

var useBreadcrumbStore = function useBreadcrumbStore() {
  return react_1.default.useContext(BreadcrumbsStoreContext);
};

exports.useBreadcrumbStore = useBreadcrumbStore;
/**
 * @private
 *
 * Wrap a breadcrumb source which is rend3red only on the server to populate
 * the store before any components which need breadcrumb store data are
 * rendered.
 *
 * @param Component
 */

var asHiddenBreadcrumbSource = function asHiddenBreadcrumbSource(Component) {
  var AsHiddenBreadcrumbSource = function AsHiddenBreadcrumbSource(props) {
    var store = useBreadcrumbStore();
    var node = core_1.useNode().node;
    server_1.default.renderToString(react_1.default.createElement(core_1.NodeProvider, {
      node: node
    }, react_1.default.createElement(BreadcrumbStoreProvider, {
      store: store
    }, react_1.default.createElement(Component, __assign({}, props)))));
    return null;
  };

  return AsHiddenBreadcrumbSource;
};

exports.asHiddenBreadcrumbSource = asHiddenBreadcrumbSource;